// spinner.component.ts
import { Component } from '@angular/core';
import { SpinnerService, SpinnerState } from '../../services/spinner.service';
import { CommonModule } from '@angular/common';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-spinner',
  imports: [CommonModule],
  template: `
   @if (spinnerState$ | async; as state) {
     @if (state.show) {
       <div
         class="spinner-container"
       [ngClass]="{
         'spinner-overlay': !state.partial,
         'spinner-no-overlay': state.partial
       }" >
         <div class="spinner"></div>
       </div>
     }
   }
   `,
  styleUrls: ['./spinner.component.css']
})
export class SpinnerComponent {
  public spinnerState$: Observable<SpinnerState>;

  constructor(private spinnerService: SpinnerService) {
    this.spinnerState$ = this.spinnerService.loading$;
  }
}
